import * as trace from 'owa-trace';
import getDateRange from './getDateRange';
import reloadCalendarEventsInCache from './reloadCalendarEventsInCache';
import { cacheReloaded, eventEmitter } from 'mini-cal-event-emitters';

/**
 * Reloads the calendar events cache for a particular folderId or entirely
 * @param folderId Calendar folder id
 */
export default async function reloadCalendarEventsAndNotify(folderId?: string) {
    const dateRange = getDateRange();
    if (dateRange) {
        try {
            await reloadCalendarEventsInCache(dateRange, folderId);
            eventEmitter.emit(cacheReloaded, folderId);
        } catch (error) {
            // TODO: For now just tracing the error. Based on the design input,
            // we can reject the promise so that the callers get to know about
            // the failure and take required action
            trace.errorThatWillCauseAlert(`[reloadCalendarEventsAndNotify]: ${error}`);
        }
    } else {
        trace.errorThatWillCauseAlert('[reloadCalendarEventsAndNotify]: No date range set');
    }
}
